// extracted by mini-css-extract-plugin
module.exports = {"whoAreWe":"styles_whoAreWe__3dVGk","info":"styles_info__e0LuN","aboutSelfSchool":"styles_aboutSelfSchool__uhDp6","image":"styles_image__mts6s"};